export default __webpack_public_path__ + "static/media/1R.49ed3f72.png";